import { Injectable } from '@angular/core';

import { Action, select, Store } from '@ngrx/store';

import * as fromVehicles from './vehicles.reducer';
import * as VehiclesSelectors from './vehicles.selectors';

@Injectable()
export class VehiclesFacade {
  loaded$ = this.store.pipe(select(VehiclesSelectors.getVehiclesLoaded));
  allVehicles$ = this.store.pipe(select(VehiclesSelectors.getAllVehicles));
  selectedVehicles$ = this.store.pipe(
    select(VehiclesSelectors.getSelectedVehicle)
  );

  paginatedData$ = this.store.pipe(select(VehiclesSelectors.getPagination));

  drivers$ = this.store.pipe(select(VehiclesSelectors.getDrivers));
  roles$ = this.store.pipe(select(VehiclesSelectors.getRoles));
  selectedDriver$ = this.store.pipe(
    select(VehiclesSelectors.getSelectedDriver)
  );
  nextPage$ = this.store.pipe(select(VehiclesSelectors.getVehiclesNextPage));

  constructor(private store: Store<fromVehicles.VehiclesPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
